var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHongKong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_26_4401)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26_4401",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26_4401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.64704 3H31.353C32.2607 3 33 3.73926 33 4.64704V22.2209C33 23.1232 32.2662 23.8625 31.3638 23.8679H4.63617C3.73383 23.8679 3 23.1286 3 22.2263V4.64704C3 3.73926 3.73926 3 4.64704 3Z",
    fill: "#DE2910"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0027 13.4312C14.339 11.882 15.9643 7.11488 19.4649 7.35405C18.7583 7.71825 18.655 8.39772 19.0572 9.02827C19.5084 9.73492 19.0137 10.8656 18.4049 11.1428C17.3993 11.594 17.1982 12.8061 18.0027 13.4312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8016 9.99041L17.595 10.3166L17.5189 9.94148L17.1493 9.84364L17.4863 9.65882L17.4646 9.27832L17.7472 9.53924L18.106 9.39791L17.9429 9.7458L18.1875 10.0393L17.8016 9.99041ZM18.0244 13.3932C17.5841 13.1649 17.2254 12.692 17.0677 12.1267C16.8884 11.4744 16.9916 10.7786 17.3504 10.2133L17.2743 10.1644C16.9047 10.7514 16.796 11.4798 16.9808 12.1538C17.1438 12.7518 17.508 13.2356 17.981 13.4802L18.0244 13.3932Z",
    fill: "#DE2910"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0027 13.4367C18.3452 9.474 23.3787 9.54466 24.2321 12.9529C23.6668 12.393 22.9873 12.5017 22.5144 13.0833C21.9817 13.7302 20.7532 13.6106 20.302 13.116C19.5682 12.2952 18.356 12.4745 18.0027 13.4367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2207 12.181L20.8511 12.0832L21.1881 11.8983L21.1663 11.5178L21.449 11.7788L21.8078 11.6374L21.6447 11.9853L21.8893 12.2789L21.5088 12.2354L21.3022 12.5561L21.2207 12.181ZM18.0516 13.4421C18.1332 12.9529 18.4702 12.4637 18.9594 12.143C19.5247 11.7733 20.2205 11.6537 20.8674 11.8168L20.8891 11.7298C20.2151 11.5613 19.4921 11.6809 18.9105 12.0669C18.3941 12.4093 18.0462 12.904 17.9592 13.4258L18.0516 13.4421Z",
    fill: "#DE2910"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0027 13.4367C21.873 12.5343 23.3678 17.3504 20.389 19.2149C20.7478 18.5028 20.4325 17.894 19.7367 17.6222C18.954 17.3178 18.6876 16.1111 19.0246 15.5294C19.5737 14.5673 19.0246 13.4747 18.0027 13.4367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1879 16.1056L20.1662 15.7251L20.4488 15.9861L20.8076 15.8447L20.6445 16.1926L20.8891 16.4861L20.5086 16.4427L20.302 16.7688L20.2259 16.3937L19.8563 16.2959L20.1879 16.1056ZM18.0136 13.4856C18.5082 13.4095 19.0736 13.5834 19.5302 13.9476C20.0574 14.3662 20.3836 14.9913 20.4271 15.6599L20.5195 15.6545C20.4706 14.9587 20.1335 14.3118 19.59 13.877C19.1062 13.491 18.5245 13.3117 18.0027 13.3932L18.0136 13.4856Z",
    fill: "#DE2910"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0027 13.4421C20.0574 16.8449 15.9371 19.753 13.2464 17.4972C14.0346 17.6168 14.5184 17.1276 14.5564 16.3829C14.6053 15.5458 15.6708 14.9206 16.3285 15.0565C17.4102 15.2794 18.2854 14.4205 18.0027 13.4421Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1382 16.3448L16.497 16.2035L16.3339 16.5514L16.5785 16.8449L16.198 16.8014L15.9914 17.1221L15.9153 16.7471L15.5457 16.6492L15.8827 16.4644L15.861 16.0839L16.1382 16.3448ZM17.9592 13.4584C18.1821 13.9041 18.1929 14.4966 17.9864 15.0457C17.7472 15.6762 17.2525 16.1817 16.6329 16.4318L16.6655 16.5187C17.3123 16.2578 17.8233 15.736 18.0679 15.0837C18.2853 14.5021 18.2745 13.8987 18.0353 13.4258L17.9592 13.4584Z",
    fill: "#DE2910"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9973 13.4367C15.3935 16.4426 11.3602 13.4258 12.6702 10.1643C12.7952 10.9525 13.4095 11.2569 14.1379 11.0667C14.9478 10.8547 15.8719 11.6755 15.948 12.3441C16.0676 13.4421 17.1547 14.0074 17.9973 13.4367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6651 12.5615L14.9098 12.8551L14.5292 12.8116L14.3227 13.1377L14.2466 12.7626L13.8715 12.6648L14.2085 12.48L14.1868 12.0995L14.4695 12.3604L14.8282 12.2191L14.6651 12.5615ZM17.9701 13.4041C17.6168 13.7574 17.0569 13.9476 16.4698 13.9205C15.7958 13.8878 15.1652 13.578 14.7358 13.0616L14.6651 13.1214C15.1109 13.6541 15.7686 13.9803 16.4644 14.0129C17.0841 14.04 17.6548 13.8444 18.0353 13.4693L17.9701 13.4041Z",
    fill: "#DE2910"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_26_4401",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26_4401"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26_4401",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHongKong);
export default __webpack_public_path__ + "static/media/HongKong.26909d3022d4425aa50fd8a772f29fb1.svg";
export { ForwardRef as ReactComponent };